import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


const __default__ = {
    name: "CoreUiChatHistoryNotification"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    text: {},
    icon: {},
    iconClass: {},
    clickable: { type: Boolean },
    rotateIcon: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'dialog centered-bubble-info': true,
            clickable: __props.clickable
        })
  }, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(emits)('click')), ["stop"])),
      style: {"max-width":"100%"}
    }, [
      (__props.icon)
        ? (_openBlock(), _createBlock(FontAwesomeIcon, {
            key: 0,
            icon: __props.icon,
            class: _normalizeClass({
                    [`${__props.iconClass} icon mr-1`]: true,
                    'rotate': __props.rotateIcon
                })
          }, null, 8, ["icon", "class"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default"),
        _createTextVNode(" " + _toDisplayString(__props.text), 1)
      ])
    ])
  ], 2))
}
}

})